import { AbstractControl, ValidationErrors } from '@angular/forms';
import moment from 'moment';

export class DateValidation {
  static validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const valueAsMoment = moment(control.value);
    const isValidDate = valueAsMoment.isValid();
    const isYearGtZero = valueAsMoment.year() > 0;

    if (isValidDate && isYearGtZero) {
      return null;
    }

    return {
      invalidDate: true
    };
  }
}

